import styled from '@emotion/styled'

import { Flex, Text } from '@cash-design-system/react'
import {
  FormBlockerElementAvatarElementAvatar,
  FormBlockerElementProfilePreviewElement,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { UiAvatar } from '@cash-web/protos/squareup/franklin/ui/ui_avatar.pb'

import { AvatarElement } from '../AvatarElement/AvatarElement'
import RemoteImageElement from '../RemoteImageElement/RemoteImageElement'

export type ProfilePreviewElementProps = FormBlockerElementProfilePreviewElement

const ProfileInfoContainer = styled.div<{ hasFooter: boolean }>`
  border: 0.125rem solid ${props => props.theme.arcadeColors.semantic.backgroundSubtle};
  border-radius: ${({ hasFooter }) => (hasFooter ? '1rem 1rem 0 0' : '1rem')};
  padding: ${({ theme }) => theme.spacing.l};
  padding-top: ${({ theme }) => theme.spacing.xl};
  display: flex;
  justify-content: center;
`

const Footer = styled.div`
  background: ${props => props.theme.arcadeColors.semantic.backgroundSubtle};
  text-align: center;
  padding: ${({ theme }) => theme.spacing.m};
  border-radius: 0 0 1rem 1rem;
`

const ProfileAvatar = ({ avatar }: { avatar?: UiAvatar }) => {
  if (avatar) {
    return <AvatarElement avatars={[avatar as FormBlockerElementAvatarElementAvatar]} />
  } else {
    return <AvatarElement avatars={[{}]} />
  }
}

export const ProfilePreviewElement = ({ avatar, caption, title, subtitle, footer }: ProfilePreviewElementProps) => {
  return (
    <>
      <ProfileInfoContainer hasFooter={!!footer}>
        <Flex flexDirection="column" alignItems="center">
          <Flex alignItems="center" flexDirection="column">
            <ProfileAvatar avatar={avatar} />
            {caption && (
              <Flex>
                {caption.icon && <RemoteImageElement image={caption.icon} width={22} height={22} />}
                {caption.text && (
                  <Text typography="metaText" color="textStandard">
                    {caption.text}
                  </Text>
                )}
              </Flex>
            )}
          </Flex>
          {title && (
            <Text typography="titleBarPageTitle" color="textStandard">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text typography="labelMedium" color="textSubtle">
              {subtitle}
            </Text>
          )}
        </Flex>
      </ProfileInfoContainer>
      {footer && (
        <Footer>
          <Text typography="helpText" color="textSubtle">
            {footer}
          </Text>
        </Footer>
      )}
    </>
  )
}
